// ws Api
import ApiNfcWs from '@/request/api-nfc_ws';
import Secret from "@/secret";

// API 类型
import ApiType from '@/request/api-type';
// API 组织结构
import ApiOam from '@/request/api-oam';
// API 人员
import ApiUser from '@/request/api-user';
// API 车辆
import ApiCar from '@/request/api-car';
// 参数信息 API
import ApiParam from '@/request/api-param';

// 组件 webSoket
import SubWebsoket from '@/components/SubWebsoket';

//================================= name =============================
/**
 * @Des 组件名称
 * @Auth
 * @Date 2021/8/9
 */
const name = 'SubWatchData';

//================================= components =============================
/**
 * @Des 注册
 * @Auth
 * @Date 2021/8/5
 */
const components = {
	// 组件 webSoket
	SubWebsoket,
};

//================================= props =============================
/**
 * @Des 属性值
 * @Auth
 * @Date 2021/8/5
 */
const props = {
	
};
//================================= created =============================
/**
 * @Des 加载完成执行
 * @Auth
 * @Date 2021/8/5
 */
const created = function () {
	// 记录 组件状态
	window.watchDataFlag = true;
};

//================================= mounted =============================
/**
 * @Des 加载执行 pre
 * @Auth
 * @Date 2021/8/5
 */
const mounted = function () {
	// 初始化声音
	this.initSoundDoc();
	
	// 开启订阅消息
	this.startSubscribes();
	
	// 初始化 search info 参数
	this.initInfoVar();
	// 初始化 queue alarms 参数
	this.initQueueVar();
	
	// 加载 map tag bs 相关 信息
	this.loadSearchInfo();
	
};

//================================= destroyed =============================
/**
 * @Des 销毁之前
 * @Auth
 * @Date 2021/8/5
 */
const beforeDestroy = function () {
	// 取消订阅消息
	this.endSubscribes();
	
	// 记录 组件状态
	window.watchDataFlag = false;
	
	// 关闭 timer
	this.endTimers();
};
/**
 * @Des 销毁
 * @Auth
 * @Date 2021/8/5
 */
const destroyed = function () {
	// 初始化websolet
	this.wsFilter.creatWsFlag = false;
};

//================================= computed =============================
/**
 * @Des 实时计算
 * @Auth
 * @Date 2021/8/5
 */
const computed = {
	
};


//================================= watch =============================
/**
 * @Des 监听
 * @Auth
 * @Date 2021/8/5
 */
const watch = {
	
};

//================================= data =============================
/**
 * @Des 数据模型
 * @Auth
 * @Date 2021/8/5
 */
const data = function () {
	return {
		
		/**
		 * @Des webSoket参数
		 * @Auth
		 * @Date 2021/7/2
		 */
		wsFilter: {
			// 创建 ws flag
			creatWsFlag: false,
			// webSoket路径
			wsUrl: ApiNfcWs.positionWs,
			// webSoket key
			wsKey: '_POSI',
			// 自动重新连接
			autoRecreatFlag: true,
			// 连接已打开
			wsOnopen: this.wsOnopen,
			// 数据推送
			wsOnmessage: this.wsOnmessage,
			// 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
			winMessageFn: null,
			// this.onMessage 与 this.wsOnmessage 存一即可
		},
		
	}
};

//================================= methods =============================
/**
 * @Des 方法
 * @Auth
 * @Date 2021/8/5
 */
//============ ws position send 1: 初始项目数据;2: 切换地图;3： 追踪;4: 取消追踪; ============
const methods = {
	/**
	 * @Des 关闭 timer
	 * @Auth
	 * @Date
	 */
	endTimers() {
		// 定时器 map tag bs 相关 信息
		if (this.timer_tagInfo != null) {
			clearTimeout(this.timer_tagInfo);
			this.timer_tagInfo = null;
		}
		// 计时器 循环 报警设备
		if (this.timer_queueTagId != null) {
			clearTimeout(this.timer_queueTagId);
			this.timer_queueTagId = null;
		}
		// 计时器 循环 报警设备
		if (this.timer_queueVoice != null) {
			clearTimeout(this.timer_queueVoice);
			this.timer_queueVoice = null;
		}
	},
	// webSoket 连接打开 onopen回调
	wsOnopen(event) {
		console.log('open websocket已连接....');
		
		// 发送心跳包
		this.$refs.positionWs.sendPing(1*60*1000, this.wsFilter.wsPingStr);
		
		const code = 40;// 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置
		const time = new Date().getTime();
		const sign = Secret.md5(time + "{" + code + "}");
		const argJson = {
			code: code,
			time: time,
			sign: sign,
			key: this.$store.state.loginKey,
		};
		this.$refs.positionWs.wsSend(argJson);
	},
	// webSoket 数据推送   onmessage回调
	wsOnmessage(event) {
		const data = event.data;
		const dataObj = eval('(' + data + ')');
		// 空值 中止
		if (this.$checkEmpty(dataObj)) return false;
		// 发布 ws位置 信息
		this.$pubsub.publish('wsMessageData', Object.assign({}, dataObj));
		
		if(dataObj.code == 1) {
			console.log('message code==1 websocket连接成功...');
			// webSoket 参数
			/*var argJson = {
				code: 2,
				mapId: ''
			};*/
			// !isItEmpty(ws) && typeof ws.send == 'function' && ws.send(jsonStr);
			
			// 发送消息 数据改变
			this.$pubsub.publish('wsCreated', dataObj.data);
		}
		
		if(dataObj.code == 100 || dataObj.code == 120) {
			//位置数据
			
			// 加载位置信息 单个
			this.loadPosiRow(Object.assign({}, dataObj.data, {status: 1}));
		}
		
		if(dataObj.code == 101) {
			//标签 发生变化
			
			// 清除计时器
			if (!this.$checkEmpty(this.timer_101)) {
				return false;
			}
			// 延后执行
			this.timer_101 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_101)) {
					clearTimeout(this.timer_101);
					this.timer_101 = null;
				}
				
				// 发送消息 数据改变
				this.$pubsub.publish('TagChange', dataObj.data);
				// 查询标签
	            this.searchUwbTag('ws');
			}, 500);
		}
		if(dataObj.code == 102) {
			//人员 发生变化
			
            // 清除计时器
			if (!this.$checkEmpty(this.timer_102)) {
				return false;
			}
			// 延后执行
			this.timer_102 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_102)) {
					clearTimeout(this.timer_102);
					this.timer_102 = null;
				}
				
				// 发送消息 人员变化
				this.$pubsub.publish('UserChange', dataObj.data);
				// 查询所有人员
	            this.searchUsers();
			}, 500);
		}
		if(dataObj.code == 103) {
			//人员组 发生变化
			
		}
		if(dataObj.code == 104) {
			//车辆 发生变化
			// 清除计时器
			if (!this.$checkEmpty(this.timer_104)) {
				return false;
			}
			// 延后执行
			this.timer_104 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_104)) {
					clearTimeout(this.timer_104);
					this.timer_104 = null;
				}
				
				// 发送消息 车辆变化
				this.$pubsub.publish('CarChange', dataObj.data);
				// 查询所有车辆
	            this.searchCars();
			}, 500);
		}
		if(dataObj.code == 105) {
			//车辆组 发生变化
			
		}
		if(dataObj.code == 106) {
			//WIFI 实时定位数据
			
		}
		if(dataObj.code == 107) {
			//数据发生变化 报警
			
			// 清除计时器
			if (!this.$checkEmpty(this.timer_107)) {
				return false;
			}
			// 延后执行
			this.timer_107 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_107)) {
					clearTimeout(this.timer_107);
					this.timer_107 = null;
				}
				
				// 数据查询 报警类型
				this.searchAlarmStatus();
				// 发送消息 数据改变
				this.$pubsub.publish('AlarmChange', dataObj.data);
			}, 500);
		}
		if(dataObj.code == 108) {
			//数据发生变化 消息通知
			
			// 清除计时器
			if (!this.$checkEmpty(this.timer_108)) {
				return false;
			}
			// 延后执行
			this.timer_108 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_108)) {
					clearTimeout(this.timer_108);
					this.timer_108 = null;
				}
				
				// 发送消息 数据改变
				this.$pubsub.publish('AppNoticeChange', dataObj.data);
			}, 500);
		}
		if(dataObj.code == 109) {
			// 变化 视频配置
			
			// 清除计时器
			if (!this.$checkEmpty(this.timer_109)) {
				return false;
			}
			// 延后执行
			this.timer_109 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_109)) {
					clearTimeout(this.timer_109);
					this.timer_109 = null;
				}
				
				// 发送消息 数据改变
				this.$pubsub.publish('VideoChange', dataObj.data);
			}, 500);
		}
		if(dataObj.code == 110) {
			// 变化 系统时间
			
			// 发送消息 数据改变
			this.$pubsub.publish('SystemTimeChange', dataObj.data);
		}
		if(dataObj.code == 111) {
			// 变化 报警开关
			
			// 报警开关
			this.alarmStateSwitchs = Object.assign({}, dataObj.data);
			
			// 发送消息 报警开关
			this.$pubsub.publish('AlarmStateChange', dataObj.data);
			// 发布 相关数据
			this.$pubsub.publish('initLocalData', {
				// 报警开关
				'alarmStateSwitchs': Object.assign({}, this.alarmStateSwitchs),
				// flag 刷新列表
				flushListFlag: false,
				// flag 刷新位置
				flushPositionFlag: false,
				// flag 定位有效时间
				flushDisappearTimeFlag: false,
			});
			
			// 数据查询 报警类型
			this.searchAlarmStatus();
		}
		if(dataObj.code == 112) {
			// 变化 离线标签
			
			// 空值 中止
			if (this.$checkEmpty(dataObj.data)) return false;
			
			let row = Object.assign({}, this.map_tag_in_position.get(dataObj.data));
			// 空值 中止
			if (this.$checkEmpty(row)) return false;
			
			// 加载位置信息 单个
			this.loadPosiRow(Object.assign({}, row, {status: 2}));
		}
		if(dataObj.code == 113) {
			// 变化 电子围栏
			
			// 清除计时器
			if (!this.$checkEmpty(this.timer_113)) {
				return false;
			}
			// 延后执行
			this.timer_113 = setTimeout(() => {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_113)) {
					clearTimeout(this.timer_113);
					this.timer_113 = null;
				}
				
				// 发送消息 数据改变
				this.$pubsub.publish('EFenceChange', dataObj.data);
			}, 500);
		}
		
//		if(dataObj.code == 103){
//			// 刷新所有数据
//			
//			// 延时执行
//			setTimeout(() => {
//				// 加载 map tag bs 相关 信息
//				this.loadSearchInfo();
//			}, 500);
//			
//		}
//		
//		if(dataObj.code == 104) {
//			const msg = dataObj.msg ? dataObj.msg : 'UWB定位引擎数据中断';
//			this.$message({
//				message: msg,
//				type: 'warning',
//				showClose: true,
//				dangerouslyUseHTMLString: true
//			});
//		}
		
	},
	
	//========================== 订阅消息 start ==========================
	/**
	 * @Des 开启订阅消息
	 * @Auth
	 * @Date 2021/8/16
	 */
	startSubscribes() {
		// 订阅消息 请求初始数据
		this.sub_dataInfo = this.$pubsub.subscribe('dataInfo', (name, data) => {
			// 发布 相关数据
			this.$pubsub.publish('initLocalData', {
				// 报警类型
				'alarmStates': Object.assign({}, this.alarmStates),
				// 报警开关
				'alarmStateSwitchs': Object.assign({}, this.alarmStateSwitchs),
				// 报警有效时间
				'disappearTime': this.disappearTime,
				// 地图 信息
				'mapsInfo': this.map_library.values(),
				// 人员 信息
				'tagUsersInfo': this.map_tag_user.values(),
				// 报警 信息
				'tagAlarmsInfo': this.map_tag_alarm.values(),
				// 位置 信息
				'tagPositionsInfo': this.map_tag_in_position.values(),
				// 定位列表 信息
				'positionKsListInfo': this.map_people_position_list.values(),
				// 报警列表 信息
				'alarmKsListInfo': this.map_people_alarm_list.values(),
				// 工具柜列表 信息
				'toolcabinetListInfo': this.map_toolcabinet_list.values(),
				// flag 刷新列表
				flushListFlag: true,
				// flag 刷新位置
				flushPositionFlag: true,
				// flag 定位有效时间
				flushDisappearTimeFlag: true,
			});
		});
		
		// 订阅消息 请求初始数据 现场人员
		this.sub_dataInfo_site = this.$pubsub.subscribe('dataInfo_site', (name, data) => {
			// 发布 相关数据
			this.$pubsub.publish('initLocalData_site', {
				// 报警类型
				'alarmStates': Object.assign({}, this.alarmStates),
				// 报警有效时间
				'disappearTime': this.disappearTime,
				// 地图 信息
				'mapsInfo': this.map_library.values(),
				// 人员 信息
				'tagUsersInfo': this.map_tag_user.values(),
				// 报警 信息
				'tagAlarmsInfo': this.map_tag_alarm.values(),
				// 位置 信息
				'tagPositionsInfo': this.map_tag_in_position.values(),
				// flag 刷新列表
				flushListFlag: true,
				// flag 刷新位置
				flushPositionFlag: true,
				// flag 定位有效时间
				flushDisappearTimeFlag: true,
			});
		});
		
		// 订阅消息 position webSoket send
		this.sub_sendPositionWs = this.$pubsub.subscribe('sendPositionWs', (name, data) => {
			// 空值 中止
			if (this.$checkEmpty(data)) return false;
			this.$nextTick(() => {
				// ws 发送数据
				this.$refs.positionWs && this.$refs.positionWs.wsSend(data);
			});
		});
		
		// 订阅消息 系统设置
		this.sub_sysSetting = this.$pubsub.subscribe('sysSetting', (name, data) => {
			// 开启/关闭 声音
			if (data == 'allowVoiceFlag') {
				this.$nextTick(() => {
					
					if(this.$store.getters.getAllowVoiceFlag) {
						// 允许播放
						// 刷新报警声音
						this.flushSoundStatus();
					} else {
						// 不允许播放
						// 刷新报警声音
						this.soundStop();
					};
				});
			}
		});
		
		// 订阅消息 通知广播
		this.sub_pubsubHandle = this.$pubsub.subscribe('pubsubHandle', (name, data) => {
			// 空值 中止
			if (this.$checkEmpty(data)) return false;
			// 报警相关数据
			if (data.key == 'getAlarmData') {
				// 报警相关数据
				
				// 发布消息 报警数据
				this.$pubsub.publish('pubsubTransData', {key: 'alarmData', data: {
					// 报警类型
					'alarmStates': Object.assign({}, this.alarmStates),
					// 报警开关
					'alarmStateSwitchs': Object.assign({}, this.alarmStateSwitchs),
					// 报警 信息
					'tagAlarmsInfo': this.map_tag_alarm.values(),
				}});// // 发布消息 报警数据
				
			}// 报警相关数据
			
		});// this.sub_pubsubHandle
		
		
	},// startSubscribes
	/**
	 * @Des 取消订阅消息
	 * @Auth
	 * @Date 2021/8/16
	 */
	endSubscribes() {
		//取消订阅 相关信息
		this.$pubsub.unsubscribe(this.sub_dataInfo);
		//取消订阅 相关信息 现场人员
		this.$pubsub.unsubscribe(this.sub_dataInfo_site);
		//取消订阅 相关信息
		this.$pubsub.unsubscribe(this.sub_sendPositionWs);
		//取消订阅 系统设置
		this.$pubsub.unsubscribe(this.sub_sysSetting);
		//取消订阅 通知广播
		this.$pubsub.unsubscribe(this.sub_pubsubHandle);
	},
	//========================== 订阅消息 end ==========================
	
	//========================== search info start ==========================
	/**
	 * @Des 初始化 search info 参数
	 * @Auth
	 * @Date 2021/8/5
	 */
	initInfoVar() {
		this.map_library = new this.HashMap();                                	// 地图信息
		this.map_tag = new this.HashMap();                                    	// 标签信息
		this.map_tag_user = new this.HashMap();                               	// 标签用户
		this.map_tag_alarm = new this.HashMap();                              	// 标签报警
		this.map_tag_in_position = new this.HashMap();                        	// 标签位置
		this.map_people_position_list = new this.HashMap();						// 人员定位列表
		this.map_people_alarm_list = new this.HashMap();						// 人员报警列表
		this.map_rangeBs_list = new this.HashMap();								// 需添加基站的测距基站
		this.map_toolcabinet_list = new this.HashMap();							// 缓存数据 工具柜
		this.alarmStates = {};													// 报警类型
		this.alarmStateSwitchs = {};											// 报警开关
		this.alarmListMap = {};													// 报警map
		this.disappearTime = null;												// 定位有效时间
		
		// 标签 list
		this.list_tags_UWB = [];												// 标签 list UWB
		this.list_tags_GNSS = [];												// 标签 list GNSS
		
		this.disappearAlarmSwitch = false;										// falg 检索定位超时
		this.Add_State = 'add'; this.Update_State = 'update'; this.Delete_State = 'delete';
		// 定时器 map tag bs 相关 信息
		this.timer_tagInfo = null;
		
		const time = new Date().getTime();
		const sign = Secret.md5(time + "{" + 0 + "}");
		const argJson = {
			code: 0,
			time: time,
			sign: sign
		};
		// 心跳包
		this.wsFilter.wsPingStr = JSON.stringify(argJson);
	},// initInfoVar
	// 加载 map tag bs 相关 信息
	loadSearchInfo() {
		return false;
		// 定时器 map tag bs 相关 信息
		if (this.timer_tagInfo != null) {
			clearTimeout(this.timer_tagInfo);
			this.timer_tagInfo = null;
		}
		// 记录 组件状态
		if (!window.watchDataFlag) return false;
		
		// webSoket 参数
		const code = 40;// 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置
		const time = new Date().getTime();
		const sign = Secret.md5(time + "{" + code + "}");
		const argJson = {
			code: code,
			time: time,
			sign: sign,
			key: this.$store.state.loginKey,
		};
		var jsonStr = JSON.stringify(argJson);
		if (this.$checkEmpty(this.$refs.positionWs)) {
			// 初始化websolet
			this.wsFilter.creatWsFlag = true;
		} else if(this.wsFilter.creatWsFlag) {
			this.$refs.positionWs.wsSend(jsonStr);
		};
		
		// 数据查询 报警类型
		this.searchAlarmStatus();
		
		return false;

	},// loadSearchInfo
	
	/**
	 * @Des 数据查询 报警类型
	 * @Auth 
	 * @Date 
	 */
	searchAlarmStatus() {
		return false;
		// 记录 组件状态
		if (!window.watchDataFlag) return false;
		
		this.$request.postJsonRequest(ApiType.findTypeApi, {
			projectId: this.$store.state.currentProjectId,
			type: "alarmTypes"
		}).then(result => {
			// 记录 组件状态
			if (!window.watchDataFlag) return false;
			if(result.code == 0 && result.data.alarmTypes){
				// 报警类型
				this.alarmStates = Object.assign({}, {});
				
				let autoDisappearFlag = true;// 自动检索消失
				let alarmTypes = Object.assign([], result.data.alarmTypes);
				alarmTypes.forEach((row, index) => {
					// 报警类型
					this.alarmStates[row.state] = Object.assign({}, row);
					if (autoDisappearFlag && row.state == 4) {
						// 自动检索消失
						autoDisappearFlag = false;
					}
				});
				
				// 自动检索消失
				if (autoDisappearFlag) {
					// 数据查询 定位有效时间
					this.searchDisappearTime();
				} else {
					// 定位有效时间
					this.disappearTime = null;
				}
			}
			
			// 数据查询 报警list
			this.searchAlarm();
		}).catch(error => {
			// 定位有效时间
			this.disappearTime = null;
			console.error('查询报警类型异常', ApiType.findTypeApi, error);
			// 数据查询 报警list
			this.searchAlarm();
		})
	},// searchAlarmStatus
	
	/**
	 * @Des 数据查询 报警list
	 * @Auth 
	 * @Date 
	 */
	searchAlarm() {
		this.$request.postJsonRequest(ApiOam.Search_Alarm_Uri, {
			projectId: this.$store.state.currentProjectId,
            dealState: [1],// 0 未处理	1 处理中	2 已处理
            orderBy: {
                alarm_date: 'desc'
            },
            total: 0,
            startNum: 0,
            limit: 0
		}).then(result => {
			// 数据列表
			//this.dataList[index].num = result.total > 0 ? result.total : 0;
			
			// 报警map 重置
			this.alarmListMap = Object.assign({}, {});
			
			// 报警 list
			let alarmList = Object.assign([], result.rows);
			// 遍历
			Object.assign([], alarmList).forEach((row, index) => {
				
				// 空值 中止
				if (this.$checkEmpty(row)) return true;
				// 报警类型不存在 中止
				// 报警类型
				if (!this.alarmStates.hasOwnProperty(row.alarm)) return true;
				
				// 已存储项
				let tagAlarms = Object.assign({}, this.alarmListMap[row.tagId]);
				tagAlarms[row.alarm] = Object.assign({}, row, {time: row.alarmDate, code: row.alarm, name: row.alarmName});
				
				// 报警map
				this.alarmListMap[row.tagId] = Object.assign({}, tagAlarms);
				
				// 刷新室内报警信息
				row.tagId && this.flushInAlarmMap(row.tagId, Object.assign({}, tagAlarms));
				
			});
			
			// 发布消息 报警数据
			this.$pubsub.publish('pubsubTransData', {key: 'alarmData', data: {
				// 报警类型
				'alarmStates': Object.assign({}, this.alarmStates),
				// 报警开关
				'alarmStateSwitchs': Object.assign({}, this.alarmStateSwitchs),
				// 报警 信息
				'tagAlarmsInfo': this.map_tag_alarm.values(),
			}});// // 发布消息 报警数据
			
			// 查询 组织结构
			this.searchOrg();
			
		}).catch(error => {
			console.error('查询报警数据异常', ApiOam.Search_Alarm_Uri, error);
			// 查询 组织结构
			this.searchOrg();
		})
	},// searchAlarm
	
	/**
	 * @Des 数据查询 定位有效时间
	 * @Auth 
	 * @Date 
	 */
	searchDisappearTime() {
		return false;
		// 记录 组件状态
		if (!window.watchDataFlag) return false;
		
		this.$request.postJsonRequest(ApiParam.getDisappearTime, {
			projectId: this.$store.state.currentProjectId,
		}).then(result => {
			if(result.code == 0 && result.data){
				// 定位有效时间
				this.disappearTime = result.data;
			} else {
				// 定位有效时间
				this.disappearTime = null;
			}
		}).catch(error => {
			// 定位有效时间
			this.disappearTime = null;
			console.error('查询定位有效时间异常', ApiParam.getDisappearTime, error);
		})
	},// searchDisappearTime
	
	/**
     * @Des 查询 组织结构
     * @Auth
     * @Date 
     */
    searchOrg() {
        // 记录 组件状态
		if (!window.watchDataFlag) return false;
        
        this.$request.postJsonRequest(ApiOam.Find_Org_Uri,{
            projectId: this.$store.state.currentProjectId
        }).then(result => {
            // 记录 组件状态
            if (!window.watchDataFlag) return false;
            
            let mapList = [];
            // 缓存 区域
            Object.assign([], result.data).forEach((row, index) => {
            	// 空值 跳过
            	if (this.$checkEmpty(row)) return true;
            	
            	if (row.level == 2) {
            		
            	}
            	if (row.level == 3) {
            		// 地图
            		mapList.push(Object.assign({}, row.node));
            	}
            });
            
            if (this.$checkEmpty(mapList)) {
            	// 定时器 map tag bs 相关 信息
	        	this.timer_tagInfo = setTimeout(() => {
			        // 记录 组件状态
			        if (!window.watchDataFlag) return false;
			        // 加载 map tag bs 相关 信息
			        this.loadSearchInfo();
			    }, 10*1000);
			    
			    return false;
            }
            
            // 加载地图
            this.loadLibraryMap(mapList);
            
            // 查询所有人员
            this.searchUsers();
        }).catch(error => {
            console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
        })
    },// searchOrg
    /**
     * @Des 查询所有人员
     * @Auth
     * @Date 
     */
    searchUsers() {
        this.$request.postJsonRequest(ApiUser.searchUserApi,{
            projectId: this.$store.state.currentProjectId,
            orderBy: {
                userName: 'asc'
            },
        }).then(result => {
            Object.assign([], result.rows).forEach((row, index) => {
            	// 刷新用户数据
            	this.flushUserMap(row.tagId, Object.assign({}, row));
            });
            
            // 查询标签
			// this.searchUwbTag();
			// 查询所有车辆
			this.searchCars();
        }).catch(error => {
            console.error('查询所有人员异常', ApiUser.searchUserApi, error);
        });
    },// searchUsers
    /**
     * @Des 查询所有车辆
     * @Auth
     * @Date 
     */
    searchCars() {
        this.$request.postJsonRequest(ApiCar.searchCarApi,{
            projectId: this.$store.state.currentProjectId,
            orderBy: {
                userName: 'asc'
            },
        }).then(result => {
            Object.assign([], result.rows).forEach((row, index) => {
            	// 刷新用户数据
            	this.flushUserMap(row.tagId, Object.assign({}, row));
            });
            
            setTimeout(() => {
            	// 查询标签
            	this.searchUwbTag();
            })
        }).catch(error => {
            console.error('查询所有人员异常', ApiUser.searchUserApi, error);
        });
    },// searchUsers
    
	/**
     * @Des 查询标签 UWB
     * @Auth 
     * @Date 
     */
    searchUwbTag(ev) {
        this.$request.postJsonRequest(ApiOam.Search_Uwb_Tag_Uri, {
            projectId: this.$store.state.currentProjectId,
            total: 0,
            startNum: 0,
            limit: 0,
        }).then(result => {
            let rows = !this.$checkEmpty(result.rows) ? Object.assign([], result.rows): [];
            // 遍历
            rows.forEach((row, index) => {
            	row.did = row.tagId;
            	if (ev == 'ws') {
            		// ws 触发
            		
            		let alarmRow = Object.assign({}, this.map_tag_alarm.get(row.tagId));
            		let alarmList = Object.assign([], alarmRow.list);
            		// 空值 跳过
            		if (alarmList.length > 0) {
            			let alarmMap = {};
	            		// 遍历
	            		alarmList.forEach((row, index) => {
	            			// 空值 跳过
	            			if (this.$checkEmpty(row)) return true;
	            			alarmMap[row.id] = Object.assign({}, row);
	            		});
	            		row.alarmMap = Object.assign({}, alarmMap);
            		}
            	} else {
            		row.alarmMap = Object.assign({}, this.alarmListMap[row.tagId]);
            	}
            });
            // 标签 list UWB
            this.list_tags_UWB = Object.assign([], rows);
            // 查询标签 GNSS
            this.searchTags_GNSS(ev);
            
            // 加载标签信息
            // this.loadTagFormMap(Object.assign([], rows));
        }).catch(error => {
            console.error('查询标签数据异常', ApiOam.Search_Uwb_Tag_Uri);
            // 标签 list UWB
            this.list_tags_UWB = Object.assign([], []);
            // 查询标签 GNSS
            this.searchTags_GNSS(ev);
        })
    },// searchUwbTag
	/**
     * @Des 查询标签 GNSS
     * @Auth 
     * @Date 
     */
	searchTags_GNSS(ev) {
		this.$request.postJsonRequest(ApiOam.Search_GNSS_Tag_Uri, {
            projectId: this.$store.state.currentProjectId,
            total: 0,
            startNum: 0,
            limit: 0,
        }).then(result => {
            let rows = !this.$checkEmpty(result.rows) ? Object.assign([], result.rows): [];
            // 遍历
            rows.forEach((row, index) => {
            	row.tagId = row.tagId || row.did;
            	if (ev == 'ws') {
            		// ws 触发
            		
            		let alarmRow = Object.assign({}, this.map_tag_alarm.get(row.tagId));
            		let alarmList = Object.assign([], alarmRow.list);
            		// 空值 跳过
            		if (alarmList.length > 0) {
            			let alarmMap = {};
	            		// 遍历
	            		alarmList.forEach((row, index) => {
	            			// 空值 跳过
	            			if (this.$checkEmpty(row)) return true;
	            			alarmMap[row.id] = Object.assign({}, row);
	            		});
	            		row.alarmMap = Object.assign({}, alarmMap);
            		}
            	} else {
            		row.alarmMap = Object.assign({}, this.alarmListMap[row.tagId]);
            	}
            });
            // 标签 list GNSS
            this.list_tags_GNSS = Object.assign([], rows);
            
            // 加载标签信息
            this.loadTagFormMap(Object.assign([], [].concat(this.list_tags_UWB).concat(this.list_tags_GNSS)));
        }).catch(error => {
            console.error('查询标签数据异常', ApiOam.Search_GNSS_Tag_Uri);
            // 标签 list GNSS
            this.list_tags_GNSS = Object.assign([], []);
            // 加载标签信息
            this.loadTagFormMap(Object.assign([], [].concat(this.list_tags_UWB).concat(this.list_tags_GNSS)));
        })
	},// searchTags_GNSS
	
	/**
	 * TODO 加载超过测距阈值基站
	 * @param {Object} rangeBsInfoMap
	 */
	loadRangeBsInfoMap(rangeBsInfoMap) {
		if (this.$checkEmpty(rangeBsInfoMap)) {
			rangeBsInfoMap = {}
		}
		
		// 缓存
		this.map_rangeBs_list.clear();
		
		for (let key in rangeBsInfoMap) {
			let row = rangeBsInfoMap[key];
			if (this.$checkEmpty(key) || this.$checkEmpty(row)) continue;
			this.map_rangeBs_list.put(key, Object.assign({}, row));
		}
	},
	/**
	 * @Des 加载数据 工具柜
	 * @Auth
	 * @Date 2021/12/1
	 */
	loadToolcabinetInfoMap(toolcabinetInfoMap) {
		if (this.$checkEmpty(toolcabinetInfoMap)) {
			toolcabinetInfoMap = {}
		}
		
		// 缓存
		this.map_toolcabinet_list.clear();
		
		// 报警list key
		let alarmKeys = [];
		for (let key in toolcabinetInfoMap) {
			let row = toolcabinetInfoMap[key];
			if (this.$checkEmpty(key) || this.$checkEmpty(row)) continue;
			
			if (!this.$checkEmpty(row.inAlarmInfos)) {
				alarmKeys.push(key);
			}
			
			// 缓存 工具柜
			this.map_toolcabinet_list.put(key, Object.assign({}, row));
		}
		// 缓存 工具柜
		this.map_toolcabinet_list.put('alarmKeys', Object.assign([], alarmKeys));
	},
	// 解析 maps data 数据
	loadMapsData(_row) {
		var row = !this.$checkEmpty(_row) ? Object.assign({}, _row) : {};
		
		const mapLibraryMap = Object.assign({}, row.mapLibraryMap);
		const tagFormMap = Object.assign({}, row.tagFormMap);
		const tagRfidFormMap = Object.assign({}, row.tagRfidFormMap);
		//const tagsFormMap = Object.assign({}, tagRfidFormMap, tagFormMap);
		const tagsFormMap = Object.assign({}, tagFormMap);
	    const rangeBsInfoMap = Object.assign({}, row.rangeBsInfoMap);
		// 数据 工具柜
		const toolcabinetInfoMap = Object.assign({}, row.toolcabinetInfoMap);
		
		this.disappearAlarmSwitch = row.disappearAlarmSwitch;
	    this.loadLibraryMap(mapLibraryMap);
	    this.loadRangeBsInfoMap(rangeBsInfoMap);
	    // 加载数据 工具柜
	    //this.loadToolcabinetInfoMap(toolcabinetInfoMap);
	    
	    this.loadTagFormMap(tagsFormMap);
	    // 刷新报警声音
		this.flushSoundStatus();
	},
	
	/**
	 * 加载地图
	 * @param map
	 */
	loadLibraryMap(mapLibraryMap) {
	    // key:mapId, values: mapLibrary
	    var posiNum_all = 0, alarmNum_all = 0;
	    var isMapStatusChange = false;// 地图属性改变
	    var isStatusNumChange = false;// 报警定位数量更改
	    var mapKeys = [];// mapLibraryMap key集合（可展示地图）
	    Object.assign([], mapLibraryMap).forEach((values, index) => {
			let key = values.mapId;
			
			var projectSubsectionInfo = !this.$checkEmpty(values.projectSubsectionInfo) ? Object.assign({}, values.projectSubsectionInfo) : {};
			var startMileage = projectSubsectionInfo.startMileage;
			var endMileage = projectSubsectionInfo.endMileage;
			var mapShowFlag = true;//this.$checkEmpty(values.subsectionId) || (!this.$checkEmpty(values.subsectionId) && startMileage != endMileage);
	        if (mapShowFlag) {
	        	mapKeys.push(key);
	        }
	        var subsectionName = projectSubsectionInfo.subsectionName;
			
	        var _posi_oList = this.map_people_position_list.get(key);
	        var _posi_List = !this.$checkEmpty(_posi_oList) && !this.$checkEmpty(_posi_oList.list) ? _posi_oList.list : [];
	        var _posiNum = _posi_List.length;
	        posiNum_all += _posiNum;
	        
	        var _alarm_oList = this.map_people_alarm_list.get(key);
	        var _alarm_List = !this.$checkEmpty(_alarm_oList) && !this.$checkEmpty(_alarm_oList.list) ? _alarm_oList.list : [];
	        var _alarmNum = _alarm_List.length;
	        alarmNum_all += _alarmNum;
	        
	        var _mapData = this.map_library.get(key);
	        _mapData = !this.$checkEmpty(_mapData) ? _mapData : {};
	        
	        if (this.$checkEmpty(_mapData) 
	        	|| _mapData.mapName != values.mapName 
	        	|| _mapData.mapUrl != values.mapUrl) {
	        	isMapStatusChange = true;
	        }
	        
	        if (this.$checkEmpty(_mapData) 
	        	|| _mapData.posiNum != _posiNum 
	        	|| _mapData.alarmNum != _alarmNum) {
	        	isStatusNumChange = true;
	        }
	        
			mapShowFlag && this.map_library.put(key, {
	            areaId: values.subsectionId,
	            mapId: values.mapId,
	            mapType: values.mapType,
	            mapName: values.mapName,
	            mapUrl: values.mapUrl,
	            mapWidth: values.mapWidth,
	            mapHeight: values.mapHeight,
	            startX: values.startX,
	            startY: values.startY,
	            scaleX: values.scaleX,
	            scaleY: values.scaleY,
	            widthScale: values.scaleX,
	            heightScale: values.scaleY,
	            projectId: values.projectId,
	            subsectionId: values.subsectionId,
	            subsectionName: subsectionName,
	            projectSubsectionInfo: projectSubsectionInfo,
	            startMileage: projectSubsectionInfo.startMileage,
	            finishMileage: projectSubsectionInfo.finishMileage,
	            workMileage: projectSubsectionInfo.workMileage,
	            endMileage: projectSubsectionInfo.endMileage,
	            posiNum: _posiNum,
	            alarmNum: _alarmNum
	        });
	        
	        if(!this.map_people_position_list.containsKey(key)){
	        	this.map_people_position_list.put(key, {mapId: key, areaId: values.subsectionId, list: []});
	        }
	        if(!this.map_people_alarm_list.containsKey(key)){
	        	this.map_people_alarm_list.put(key, {mapId: key, areaId: values.subsectionId, list: []});
	        }
	    });
	    
	    if (isMapStatusChange) {
	    	// 初始化 以及区域 下拉框 数据
	    	//typeof childWind.initSelectData_1st == 'function' && childWind.initSelectData_1st();
	    }
	    
	    if (isStatusNumChange) {
	    	// 更改 map-tab 数据
			//typeof childWind.dataTabItem == 'function' && childWind.dataTabItem(this.map_library.values());
	    }
	    
	    if(mapKeys.length != this.map_library.size()){
	    	var _keys = [].concat(this.map_library.keySet());
	    	for (var i in _keys){
	    		var exist = mapKeys.indexOf(_keys[i]) > -1;
	    		if(!exist){
	    			this.map_library.containsKey(_keys[i]) && this.map_library.remove(_keys[i]);
		           	this.map_people_position_list.containsKey(_keys[i]) && this.map_people_position_list.remove(_keys[i]);
		           	this.map_people_alarm_list.containsKey(_keys[i]) && this.map_people_alarm_list.remove(_keys[i]);
	    		}
	    	}
	    }
	},
	
	//============================================================== 人员位置解析 start ==============================================================\\
	/**
	 * 加载标签信息
	 * @param tagFormMap
	 */
	loadTagFormMap(tagFormMap) {
		
		var userSize_old = this.map_tag_user.size();
		let userChangeFlag = false;
		
	    // key:tagId, row: tagFormMap
	    Object.assign([], tagFormMap).forEach((row, index) => {
	    	// 空值 跳过
			if (this.$checkEmpty(row)) return true;
	    	let key = row.tagId || row.did;
	    	
			// 字段转换
			row.tagInAlarmInfos = row.alarmMap;
			
			row.appId = row.appId || this.$store.state.appId;
			row.bindingId = row.bindingId || row.bindId;
			row.bindingType = row.bindingType || row.bindType;
			row.bindingTime = row.bindingTime || row.bindTime;
			row.updateTime = row.updateTime || row.uploadTime;
			row.time = row.time || row.uploadTime;
			row.status = row.status || 1;
			
			// position alarm 与 alarm list 不一致
			var isTagAlarmed = this.$checkEmpty(row.tagInAlarmInfos) ? 0 : 1;
			// 矫正 position对象中 alarm值
			if (row.alarm != isTagAlarmed) {
				row.alarm = isTagAlarmed;
			}
			
			// 人员信息
			var userBaseInfo = this.map_tag_user.get(key);
			userBaseInfo = !this.$checkEmpty(userBaseInfo) ? userBaseInfo : {};
			
			// 记录
			let _tagInPositionInfo = Object.assign({}, this.map_tag_in_position.get(key));
			
			// 位置信息
			const tagInPositionInfo = {
				'appId': row.appId,
				'projectId': row.projectId,
				'areaId': row.areaId,
				'mapId': row.mapId,
				'tagId': row.tagId,
				'alarm': row.alarm,
				'areaPixelX': row.areaPixelX,
				'areaPixelY': row.areaPixelY,
				'areaPointX': row.areaPointX,
				'areaPointY': row.areaPointY,
				'pointX': row.pointX,
				'pointY': row.pointY,
				'pointZ': row.pointZ,
				'pixelX': row.pixelX,
				'pixelY': row.pixelY,
				'updateTime': row.updateTime,
				'time': row.updateTime,
				'videoAddress': _tagInPositionInfo.videoAddress,
				'videoId': _tagInPositionInfo.videoId,
				
				'battery': row.battery,
				'bindingId': row.bindingId,
				'bindingType': row.bindingType,
				'status': row.status,// 1 在线 2 离线
			};
			
			if(row.bindingType == 0) {
				// 解绑：Delete
				if(this.map_tag_in_position.containsKey(key)){
					var tagInPosition = this.map_tag_in_position.get(key);
					tagInPosition = !this.$checkEmpty(tagInPosition) ? tagInPosition : {};
					if(this.map_tag_user.containsKey(key)){
						if(tagInPosition.alarm == 0){
							if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
								var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
								var _index = _list.indexOf(key);
								_index > -1 && _list.splice(_index, 1);
								this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
								this.map_tag_user.containsKey(key) && this.map_tag_user.remove(key);
								this.flushPeoplePositionList(key, this.Delete_State, tagInPosition.mapId);
							}
						}else{
							if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
								var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
								var _index = _list.indexOf(key);
								_index > -1 && _list.splice(_index, 1);
								this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
								this.map_tag_user.containsKey(key) && this.map_tag_user.remove(key);
								this.flushInAlarmMap(key, row.tagInAlarmInfos);
								this.flushPeopleAlarmList(key, this.Delete_State, tagInPosition.mapId);
							}
						}
					}
				}
				// 移除对象
				this.map_tag.containsKey(key) && this.map_tag.remove(key);
				this.map_tag_user.containsKey(key) && this.map_tag_user.remove(key);
				this.map_tag_alarm.containsKey(key) && this.map_tag_alarm.remove(key);
				this.map_tag_in_position.containsKey(key) && this.map_tag_in_position.remove(key);
			}else{
	       		// 绑定
	       		if(!this.map_tag.containsKey(key)){
	       			// 第一次绑定
	       			var tagInPosition = !this.$checkEmpty(tagInPositionInfo) ? tagInPositionInfo : {};
	       			tagInPosition = !this.$checkEmpty(tagInPosition) ? tagInPosition : {};
		       		if(!this.$checkEmpty(userBaseInfo)){
		       			if(tagInPosition.alarm == 0){
			       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
		       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
			       				var _index = _list.indexOf(key);
			       				_index == -1 && _list.push(key);
		       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
		       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
		       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
			       			}
			       		}else{
			       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
		       					var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
			       				var _index = _list.indexOf(key);
			       				_index == -1 && _list.push(key);
		       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
		       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
		       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
			       			}
		       			}
		       		}
	       		}else {
	       			// 第N次绑定 ，判断报警状态是否变化
	       			if(this.map_tag_in_position.containsKey(key)){
	       				var oldTagInPosition = this.map_tag_in_position.get(key);
	       				oldTagInPosition = !this.$checkEmpty(oldTagInPosition) ? oldTagInPosition : {};
	       				var tagInPosition = !this.$checkEmpty(tagInPositionInfo) ? tagInPositionInfo : {};
	       				tagInPosition = !this.$checkEmpty(tagInPosition) ? tagInPosition : {};
	       				if(oldTagInPosition.mapId == tagInPosition.mapId){
	       					if( tagInPosition.alarm != oldTagInPosition.alarm){
	       						if(this.map_tag_user.containsKey(key)){
					       			if(tagInPosition.alarm == 0){
						       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
					       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
						       				var _index = _list.indexOf(key);
						       				_index == -1 && _list.push(key);
					       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
					       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
					       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
						       			}
						       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
						       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
						       				var _index = _list.indexOf(key);
						       				_index > -1 && _list.splice(_index, 1);
					       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
					       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
					       					this.flushPeopleAlarmList(key, this.Delete_State, tagInPosition.mapId);
						       			}
						       		}else{
						       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
						       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
						       				var _index = _list.indexOf(key);
						       				_index == -1 && _list.push(key);
					       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
					       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
					       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
						       			}
						       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
						       				var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
						       				var _index = _list.indexOf(key);
						       				_index > -1 && _list.splice(_index, 1);
					       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
					       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
					       					this.flushPeoplePositionList(key, this.Delete_State, tagInPosition.mapId);
						       			}
					       			}
			       				}
	       					} else {
	       						if (tagInPosition.alarm == 0) {
	       							
	       							if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
				       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index == -1 && _list.push(key);
				       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
					       			}
					       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index > -1 && _list.splice(_index, 1);
				       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeopleAlarmList(key, this.Delete_State, tagInPosition.mapId);
					       			}
	       							
	       							// 刷新子页面定位列表
	       							this.flushPeoplePositionList(key, this.Update_State, tagInPosition.mapId);
	       						} else {
	       							var oldTagInAlarmRow = this.map_tag_alarm.get(key);
	       							var oldTagInAlarmInfos = !this.$checkEmpty(oldTagInAlarmRow) && !this.$checkEmpty(oldTagInAlarmRow.list) ? oldTagInAlarmRow.list : [];
	       							row.tagInAlarmInfos = !this.$checkEmpty(row.tagInAlarmInfos) ? row.tagInAlarmInfos : [];
	       							
	       							if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index == -1 && _list.push(key);
				       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
					       			}
					       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index > -1 && _list.splice(_index, 1);
				       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeoplePositionList(key, this.Delete_State, tagInPosition.mapId);
					       			}
	       							
	       							if (row.tagInAlarmInfos.length != oldTagInAlarmInfos.length) {
	       								// 刷新室内报警信息
	       								this.flushInAlarmMap(key, row.tagInAlarmInfos);
	       								// 刷新子页面报警列表
	       								this.flushPeopleAlarmList(key, this.Update_State, tagInPosition.mapId);
	       							}
	       						}
	       					}
	       				}else{
	       					if(this.map_tag_user.containsKey(key)){
	       						if(this.map_people_position_list.containsKey(oldTagInPosition.mapId)){
				       				var _list = this.map_people_position_list.get(oldTagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index > -1 && _list.splice(_index, 1);
			       					this.map_people_position_list.put (oldTagInPosition.mapId, {mapId: oldTagInPosition.mapId, areaId: oldTagInPosition.areaId, list: _list});
			       					this.flushPeoplePositionList(key, this.Delete_State, oldTagInPosition.mapId);
				       			}
	       						if(this.map_people_alarm_list.containsKey(oldTagInPosition.mapId)){
				       				var _list = this.map_people_alarm_list.get(oldTagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index > -1 && _list.splice(_index, 1);
			       					this.map_people_alarm_list.put (oldTagInPosition.mapId, {mapId: oldTagInPosition.mapId, areaId: oldTagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeopleAlarmList(key, this.Delete_State, oldTagInPosition.mapId);
				       			}
	       						
				       			if(tagInPosition.alarm == 0){
					       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
				       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index == -1 && _list.push(key);
				       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
					       			}
					       		}else{
					       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index == -1 && _list.push(key);
				       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
					       			}
				       			}
		       				}
	       				}
	       			}else{
	       				var tagInPosition = !this.$checkEmpty(tagInPositionInfo) ? tagInPositionInfo : {};
	       				tagInPosition = !this.$checkEmpty(tagInPosition) ? tagInPosition : {};
	       				!this.$checkEmpty(tagInPosition) && this.flushInPositionMap(key, tagInPositionInfo);
			       		if(this.map_tag_user.containsKey(key)){
			       			if(tagInPosition.alarm == 0){
				       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
				       				var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index == -1 && _list.push(key);
			       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
				       			}
				       		}else{
				       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
				       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index == -1 && _list.push(key);
			       					this.map_people_alarm_list.put(tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
				       			}
			       			}
			       		}
	       			}
	       		}
			}
			this.flushTagMap(key, row);
			this.flushInPositionMap(key, tagInPositionInfo);
			this.flushInAlarmMap(key, row.tagInAlarmInfos);
			
		});
		
		// 发布 相关数据
		this.$pubsub.publish('initLocalData', {
			// 报警类型
			'alarmStates': Object.assign({}, this.alarmStates),
			// 报警开关
			'alarmStateSwitchs': Object.assign({}, this.alarmStateSwitchs),
			// 报警有效时间
			'disappearTime': this.disappearTime,
			// 地图 信息
			'mapsInfo': this.map_library.values(),
			// 人员 信息
			'tagUsersInfo': this.map_tag_user.values(),
			// 报警 信息
			'tagAlarmsInfo': this.map_tag_alarm.values(),
			// 位置 信息
			'tagPositionsInfo': this.map_tag_in_position.values(),
			// 定位列表 信息
			'positionKsListInfo': this.map_people_position_list.values(),
			// 报警列表 信息
			'alarmKsListInfo': this.map_people_alarm_list.values(),
			// 工具柜列表 信息
			'toolcabinetListInfo': this.map_toolcabinet_list.values(),
			// flag 刷新列表
			flushListFlag: true,
			// flag 刷新位置
			flushPositionFlag: true,
			// flag 定位有效时间
			flushDisappearTimeFlag: true,
		});
		
		// 发布 相关数据
		this.$pubsub.publish('initLocalData_site', {
			// 报警类型
			'alarmStates': Object.assign({}, this.alarmStates),
			// 报警开关
			'alarmStateSwitchs': Object.assign({}, this.alarmStateSwitchs),
			// 报警有效时间
			'disappearTime': this.disappearTime,
			// 地图 信息
			'mapsInfo': this.map_library.values(),
			// 人员 信息
			'tagUsersInfo': this.map_tag_user.values(),
			// 报警 信息
			'tagAlarmsInfo': this.map_tag_alarm.values(),
			// 位置 信息
			'tagPositionsInfo': this.map_tag_in_position.values(),
			// flag 刷新列表
			flushListFlag: true,
			// flag 刷新位置
			flushPositionFlag: true,
			// flag 定位有效时间
			flushDisappearTimeFlag: true,
		});
	},
	
	/**
	 * 加载位置信息 单个
	 * @param row
	 */
	loadPosiRow(row) {
		// 空值 跳过
		if (this.$checkEmpty(row)) return true;
		const key = row.tagId || row.did;
		
		// 字段转换
		row.tagInAlarmInfos = row.alarmMap;
		
		row.appId = row.appId || this.$store.state.appId;
		row.bindingId = row.bindingId || row.bindId;
		row.bindingType = row.bindingType || row.bindType;
		row.bindingTime = row.bindingTime || row.bindTime;
		row.updateTime = row.updateTime || row.uploadTime;
		row.time = row.time || row.uploadTime;
		row.status = row.status || 1;
		
		// position alarm 与 alarm list 不一致
		var isTagAlarmed = this.$checkEmpty(row.tagInAlarmInfos) ? 0 : 1;
		// 矫正 position对象中 alarm值
		if (row.alarm != isTagAlarmed) {
			row.alarm = isTagAlarmed;
		}
		var userBaseInfo = this.map_tag_user.get(key);
		userBaseInfo = !this.$checkEmpty(userBaseInfo) ? userBaseInfo : {};
		
		// tagInPositionInfo
		const tagInPositionInfo = {
			'appId': row.appId,
			'projectId': row.projectId,
			'areaId': row.areaId,
			'mapId': row.mapId,
			'tagId': row.tagId,
			'alarm': row.alarm,
			'areaPixelX': row.areaPixelX,
			'areaPixelY': row.areaPixelY,
			'areaPointX': row.areaPointX,
			'areaPointY': row.areaPointY,
			'pointX': row.tagX,
			'pointY': row.tagY,
			'pointZ': row.tagZ,
			'pixelX': row.pixelX,
			'pixelY': row.pixelY,
			'updateTime': row.updateTime,
			'time': row.time,
			'videoAddress': row.videoAddress,
			'videoId': row.videoId,
			
			'battery': row.battery,
			'bindingId': row.bindingId,
			'bindingType': row.bindingType,
			'status': row.status,// 1 在线 2 离线
		};
		
		if(row.bindingType == 0) {
			// 解绑：Delete
			if(this.map_tag_in_position.containsKey(key)){
				var tagInPosition = this.map_tag_in_position.get(key);
				tagInPosition = !this.$checkEmpty(tagInPosition) ? tagInPosition : {};
				if(this.map_tag_user.containsKey(key)){
					if(tagInPosition.alarm == 0){
						if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
							var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
							var _index = _list.indexOf(key);
							_index > -1 && _list.splice(_index, 1);
							this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
							this.map_tag_user.containsKey(key) && this.map_tag_user.remove(key);
							this.flushPeoplePositionList(key, this.Delete_State, tagInPosition.mapId);
						}
					}else{
						if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
							var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
							var _index = _list.indexOf(key);
							_index > -1 && _list.splice(_index, 1);
							this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
							this.map_tag_user.containsKey(key) && this.map_tag_user.remove(key);
							this.flushInAlarmMap(key, row.tagInAlarmInfos);
							this.flushPeopleAlarmList(key, this.Delete_State, tagInPosition.mapId);
						}
					}
				}
			}
			// 移除对象
			this.map_tag.containsKey(key) && this.map_tag.remove(key);
			this.map_tag_user.containsKey(key) && this.map_tag_user.remove(key);
			this.map_tag_alarm.containsKey(key) && this.map_tag_alarm.remove(key);
			this.map_tag_in_position.containsKey(key) && this.map_tag_in_position.remove(key);
		}else{
       		// 绑定
       		if(!this.map_tag.containsKey(key)){
       			// 第一次绑定
       			var tagInPosition = !this.$checkEmpty(tagInPositionInfo) ? tagInPositionInfo : {};
	       		if(!this.$checkEmpty(userBaseInfo)){
	       			if(tagInPosition.alarm == 0){
		       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
	       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
		       				var _index = _list.indexOf(key);
		       				_index == -1 && _list.push(key);
	       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
	       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
	       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
		       			}
		       		}else{
		       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
	       					var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
		       				var _index = _list.indexOf(key);
		       				_index == -1 && _list.push(key);
	       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
	       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
	       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
		       			}
	       			}
	       		}
       		}else {
       			// 第N次绑定 ，判断报警状态是否变化
       			if(this.map_tag_in_position.containsKey(key)){
       				// 已有定位数据
       				var oldTagInPosition = this.map_tag_in_position.get(key);
       				oldTagInPosition = !this.$checkEmpty(oldTagInPosition) ? oldTagInPosition : {};
       				var tagInPosition = !this.$checkEmpty(tagInPositionInfo) ? tagInPositionInfo : {};
       				if(oldTagInPosition.mapId == tagInPosition.mapId){
       					// 同一地图
       					if( tagInPosition.alarm != oldTagInPosition.alarm){
       						if(this.map_tag_user.containsKey(key)){
				       			if(tagInPosition.alarm == 0){
					       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
				       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index == -1 && _list.push(key);
				       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
					       			}
					       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index > -1 && _list.splice(_index, 1);
				       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeopleAlarmList(key, this.Delete_State, tagInPosition.mapId);
					       			}
					       		}else{
					       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index == -1 && _list.push(key);
				       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
					       			}
					       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
					       				var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
					       				var _index = _list.indexOf(key);
					       				_index > -1 && _list.splice(_index, 1);
				       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
				       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
				       					this.flushPeoplePositionList(key, this.Delete_State, tagInPosition.mapId);
					       			}
				       			}
		       				}
       					} else {
       						if (tagInPosition.alarm == 0) {
       							
       							if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
			       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index == -1 && _list.push(key);
			       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
				       			}
				       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
				       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index > -1 && _list.splice(_index, 1);
			       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeopleAlarmList(key, this.Delete_State, tagInPosition.mapId);
				       			}
       							
       							// 刷新子页面定位列表
       							this.flushPeoplePositionList(key, this.Update_State, tagInPosition.mapId);
       						} else {
       							var oldTagInAlarmRow = this.map_tag_alarm.get(key);
       							var oldTagInAlarmInfos = !this.$checkEmpty(oldTagInAlarmRow) && !this.$checkEmpty(oldTagInAlarmRow.list) ? oldTagInAlarmRow.list : [];
       							row.tagInAlarmInfos = !this.$checkEmpty(row.tagInAlarmInfos) ? row.tagInAlarmInfos : [];
       							
       							if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
				       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index == -1 && _list.push(key);
			       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
				       			}
				       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
				       				var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index > -1 && _list.splice(_index, 1);
			       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeoplePositionList(key, this.Delete_State, tagInPosition.mapId);
				       			}
       							
       							if (row.tagInAlarmInfos.length != oldTagInAlarmInfos.length) {
       								// 刷新室内报警信息
       								this.flushInAlarmMap(key, row.tagInAlarmInfos);
       								// 刷新子页面报警列表
       								this.flushPeopleAlarmList(key, this.Update_State, tagInPosition.mapId);
       							}
       						}
       					}
       				}else{
       					// 切换地图
       					if(this.map_tag_user.containsKey(key)){
       						// 有人员信息
       						// 从旧地图移除
       						if(this.map_people_position_list.containsKey(oldTagInPosition.mapId)){
			       				var _list = this.map_people_position_list.get(oldTagInPosition.mapId).list;
			       				var _index = _list.indexOf(key);
			       				_index > -1 && _list.splice(_index, 1);
		       					this.map_people_position_list.put (oldTagInPosition.mapId, {mapId: oldTagInPosition.mapId, areaId: oldTagInPosition.areaId, list: _list});
		       					this.flushPeoplePositionList(key, this.Delete_State, oldTagInPosition.mapId);
			       			}
       						if(this.map_people_alarm_list.containsKey(oldTagInPosition.mapId)){
			       				var _list = this.map_people_alarm_list.get(oldTagInPosition.mapId).list;
			       				var _index = _list.indexOf(key);
			       				_index > -1 && _list.splice(_index, 1);
		       					this.map_people_alarm_list.put (oldTagInPosition.mapId, {mapId: oldTagInPosition.mapId, areaId: oldTagInPosition.areaId, list: _list});
		       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
		       					this.flushPeopleAlarmList(key, this.Delete_State, oldTagInPosition.mapId);
			       			}
       						
       						// 加入新地图
			       			if(tagInPosition.alarm == 0){
				       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
			       					var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index == -1 && _list.push(key);
			       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
				       			}
				       		}else{
				       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
				       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
				       				var _index = _list.indexOf(key);
				       				_index == -1 && _list.push(key);
			       					this.map_people_alarm_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
			       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
			       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
				       			}
			       			}
	       				}
       				}
       			}else{
       				// 第一次有定位数据
       				var tagInPosition = !this.$checkEmpty(tagInPositionInfo) ? tagInPositionInfo : {};
       				!this.$checkEmpty(tagInPosition) && this.flushInPositionMap(key, tagInPosition);// this.flushInPositionMap(key, row);
		       		if(this.map_tag_user.containsKey(key)){
		       			// 有人员信息
		       			if(tagInPosition.alarm == 0){
			       			// 正常
			       			if(this.map_people_position_list.containsKey(tagInPosition.mapId)){
			       				var _list = this.map_people_position_list.get(tagInPosition.mapId).list;
			       				var _index = _list.indexOf(key);
			       				_index == -1 && _list.push(key);
		       					this.map_people_position_list.put (tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
		       					this.flushPeoplePositionList(key, this.Add_State, tagInPosition.mapId);
			       			}
			       		}else{
			       			// 报警
			       			if(this.map_people_alarm_list.containsKey(tagInPosition.mapId)){
			       				var _list = this.map_people_alarm_list.get(tagInPosition.mapId).list;
			       				var _index = _list.indexOf(key);
			       				_index == -1 && _list.push(key);
		       					this.map_people_alarm_list.put(tagInPosition.mapId, {mapId: tagInPosition.mapId, areaId: tagInPosition.areaId, list: _list});
		       					this.flushInAlarmMap(key, row.tagInAlarmInfos);
		       					this.flushPeopleAlarmList(key, this.Add_State, tagInPosition.mapId);
			       			}
		       			}
		       		}
       			}
       		}
		}
		//this.flushTagMap(key, row.tagInfo);
		this.flushInPositionMap(key, tagInPositionInfo);
		this.flushInAlarmMap(key, row.tagInAlarmInfos);
		
		// 发布 相关数据
		this.$pubsub.publish('initLocalData', {
			// 报警 信息
			'tagAlarmsInfo': this.map_tag_alarm.values(),
			// 位置 信息
			'tagPositionsInfo': this.map_tag_in_position.values(),
			// 定位列表 信息
			'positionKsListInfo': this.map_people_position_list.values(),
			// 报警列表 信息
			'alarmKsListInfo': this.map_people_alarm_list.values(),
			// flag 刷新列表
			flushListFlag: true,
			// flag 刷新位置
			flushPositionFlag: false,
			// flag 定位有效时间
			flushDisappearTimeFlag: false,
		});
		
		// 发布 相关数据
		this.$pubsub.publish('initLocalData_site', {
			// 报警 信息
			'tagAlarmsInfo': this.map_tag_alarm.values(),
			// 位置 信息
			'tagPositionsInfo': this.map_tag_in_position.values(),
			// flag 刷新列表
			flushListFlag: true,
			// flag 刷新位置
			flushPositionFlag: true,
			// flag 定位有效时间
			flushDisappearTimeFlag: false,
		});
		
		// 发布 ws位置 信息
		this.$pubsub.publish('wsPositionInfo', Object.assign({}, tagInPositionInfo));
	},
	
	/**
	 * 刷新人员定位列表
	 * @param {Object} tagId
	 * @param {Object} state : add, upd, del
	 */
	flushPeoplePositionList(tagId, state, mapId){
		return false;
		
		var childWind = document.querySelector('#rightFrame')[0].contentWindow;
		if(state == this.Add_State){
			//改变信息列表 定位 添加
			typeof childWind.addPeoTableItem_posi == 'function' && childWind.addPeoTableItem_posi(tagId, mapId);
		}else if(state == this.Update_State){
			//改变信息列表 定位 编辑
			typeof childWind.editPeoTableItem_posi == 'function' && childWind.editPeoTableItem_posi(tagId, mapId);
		}else if(state == this.Delete_State){
			//改变信息列表 定位 删除
			typeof childWind.delPeoTableItem_posi == 'function' && childWind.delPeoTableItem_posi(tagId, mapId);
		}
	},
	
	
	/**
	 * 刷新人员报警列表
	 * @param {Object} tagId
	 * @param {Object} state
	 */
	flushPeopleAlarmList(tagId, state, mapId){
		return false;
		
		var childWind = document.querySelector('#rightFrame')[0].contentWindow;
		if(state == this.Add_State){
			//改变信息列表 报警 添加
			typeof childWind.addPeoTableItem_alarm == 'function' && childWind.addPeoTableItem_alarm(tagId, mapId);
		}else if(state == this.Update_State){
			//改变信息列表 报警 编辑
			typeof childWind.editPeoTableItem_alarm == 'function' && childWind.editPeoTableItem_alarm(tagId, mapId);
		}else if(state == this.Delete_State){
			//改变信息列表 报警 删除
			typeof childWind.delPeoTableItem_alarm == 'function' && childWind.delPeoTableItem_alarm(tagId, mapId);
		}
		// 查询报警数据
		_searchList_alarm();
	},
	
	/**
	 * 刷新标签数据
	 * @param key       tagId
	 * @param value     tag
	 */
	flushTagMap(key, value) {
	    // 空值 中止
	    if (this.$checkEmpty(key) || this.$checkEmpty(value)) return false;
	    
	    // 工具
	    if (value.toolType) {
	    	this.map_tag.put(key,{
		        tagId: key,
		        tagType: value.tagType,
		        status: value.status,
		        battery: value.battery,
		        bindingType: value.bindingType,
		        bindingId: value.bindingId,
		        bindingName: value.bindingName,
		        bindingTime: value.bindingTime,
		        createTime: value.createTime,
		        updateTime: value.updateTime,
		        projectId: value.projectId
		    });
		    return false;
	    }
	    // UWB
	    this.map_tag.put(key,{
	        sid: value.sid,
	        tagId: value.tagId,
	        tagType: value.tagType,
	        tagRate: value.tagRate,
	        status: value.status,
	        battery: value.battery,
	        bindingType: value.bindingType,
	        bindingId: value.bindingId,
	        bindingName: value.bindingName,
	        bindingTime: value.bindingTime,
	        createTime: value.createTime,
	        updateTime: value.updateTime,
	        projectId: value.projectId,
	        mapIds: value.mapIds
	    })
	},
	
	/**
	 * 刷新用户数据
	 * @param key       tagId
	 * @param value     userBase
	 */
	flushUserMap(key, value) {
	    // 空值 中止
	    if (this.$checkEmpty(key) || this.$checkEmpty(value)) return false;
	    
	    // 工具
	    if (value.toolType) {
	    	this.map_tag_user.put(key,{
		        tagId: key,
		        toolId: value.toolId,
		        toolName: value.toolName,
		        toolNum: value.toolNum,
		        toolType: value.toolType,
		        groupId: value.groupId,
		        groupName: value.groupName,
		        remark: value.remark,
		        status: value.status,
		        toolCabinetId: value.toolCabinetId,
		        toolCabinetName: value.toolCabinetName,
		        createTime: value.createTime,
		        updateTime: value.updateTime,
		    });
		    return false;
	    }
	    
	    if (value.carType) {
	    	this.map_tag_user.put(key,{
		        tagId: key,
		        alarmAddr: value.alarmAddr,
				carId: value.carId,
				carNumber: value.carNumber,
				carType: value.carType,
				code: value.code,
				createTime: value.createTime,
				groupId: value.groupId,
				groupName: value.groupName,
				id: value.id,
				idCard: value.idCard,
				message: value.message,
				phone: value.phone,
				phoneCode: value.phoneCode,
				projectId: value.projectId,
				remarks: value.remarks,
				safeDistance: value.safeDistance,
				sex: value.sex,
				tagId: value.tagId,
				updateTime: value.updateTime,
				userId: value.userId,
				userName: value.userName,
				userNamePy: value.userNamePy,
				zoneOfAction: value.zoneOfAction
		    });
	    	return false;
	    }
	    
	    // UWB
	    this.map_tag_user.put(key,{
	        tagId: key,
	        userId: value.userId,
	        typeId: value.typeId,
	        groupId: value.groupId,
	        userNo: value.userNo,
	        userName: value.userName,
	        userNamePy: value.userNamePy,
	        sex: value.sex,
	        phoneCode: value.phoneCode,
	        phone: value.phone,
	        idCard: value.idCard,
	        portrait: value.portrait,
	        duty: value.duty,
	        status: value.status,
	        groupName: value.groupName,
	        visitTime: value.visitTime
	    });
	},
	
	
	/**
	 * 刷新室内位置信息
	 * @param key       tagId
	 * @param value     tagInPosition
	 */
	flushInPositionMap(key, value) {
	    // 空值 中止
	    if (this.$checkEmpty(key) || this.$checkEmpty(value) || this.$checkEmpty(value.mapId)) return false;
	    this.map_tag_in_position.put(key,{
	        tagId: value.tagId,
	        bindingType: value.bindingType,
	        alarm: value.alarm,
	        mapId: value.mapId,
	        areaId: value.areaId,
	        pointX: value.pointX,
	        pointY: value.pointY,
	        pointZ: value.pointZ,
	        pixelX: value.pixelX,
	        pixelY: value.pixelY,
	        areaPointX: value.areaPointX,
			areaPointY: value.areaPointY,
	        areaPixelX: value.areaPixelX,
	        areaPixelY: value.areaPixelY,
	        updateTime: value.updateTime,
	        time: value.time,
	        videoAddress: value.videoAddress,
	        videoId: value.videoId,
	        status: value.status,
	        projectId: value.projectId,
	    })
	},
	
	
	/**
	 * 刷新室内报警信息
	 * @param key       tagId
	 * @param value     tagInPosition
	 */
	flushInAlarmMap(key, value) {
	    // 调用子页面方法
		/*var childWind = document.querySelector('#rightFrame').contentWindow;
	    // 空值 中止
	    if (this.$checkEmpty(value)) {
	    	if (this.map_tag_alarm.containsKey(key)) {
				this.map_tag_alarm.remove(key);
				//改变信息列表 报警 删除
				typeof childWind.delPeoTableItem_alarm == 'function' && childWind.delPeoTableItem_alarm(key);
			}
	    	return false;
	    }*/
		
		// 空值 中止
		if (this.$checkEmpty(key) || typeof (value) != 'object') return false;
		
	    var alarmList = [];
	    for (var n in Object.assign({}, value)) {
	    	let row = value[n];
	    	alarmList.push({
	            id: n,
	            code: row.code,
	            count: row.count,
	            alarmName: row.name || row.alarmName,
	            time: row.time,
	        });
	    }
	    this.map_tag_alarm.put(key,{tagId: key, list: alarmList});
	    // list 记录报警设备id
		this.alarmTagIds.indexOf(key) == -1 && this.alarmTagIds.push(key);
	},
	//============================================================== 人员位置解析 end ==============================================================\\
	
	// 刷新报警声音
	flushSoundStatus() {
		var alarmMap = this.map_tag_alarm.values();
		var voiceNum = 0;
		let alarmNum = 0;// 报警人员数量
		alarmMap.forEach((row, index) => {
			// 空值 跳过
			if (this.$checkEmpty(row.list)) return true;
			alarmNum++;
			for (var i in row.list) {
				var v = row[i];
				
				// 空值 跳过
				if (this.$checkEmpty(v)) continue;
				var voiceIsOpen = v.voiceIsOpen;
				if(voiceIsOpen) {
					voiceNum++;
					continue;
				}
			};
		});
		
		// voiceNum > 0
		if (alarmNum > 0) {
			//开始播放 声音
			typeof this.soundStart == 'function' && this.soundStart();
			
			// 开始播放 队列
			//!this.voiceQueueFlag && this.startVoiceQueue();
			
		} else {
			//停止播放声音
			typeof this.soundStop == 'function' && this.soundStop();
			
			// 关闭声音 队列
			//this.stopVoiceQueue();
		}
		
		// 广播 报警人员数量
		this.$pubsub.publish('allAlarmNum', alarmNum);
		
//		var	$alarmNum = document.querySelector('#alarmNum');
//		var v_alarmNum = $alarmNum.getInnerHTML();
//		var alarmNum = this.map_tag_alarm.size();
//		v_alarmNum != alarmNum && $alarmNum.getInnerHTML(alarmNum);
//		var v_voiceNum = $alarmNum.attr('voice_num') ? $alarmNum.attr('voice_num') : 0;
//		v_voiceNum != voiceNum && $alarmNum.attr({'voice_num': voiceNum});
	},
	//========================== search info start ==========================
	
	//=========================  播放报警音 start  ======================== \\
	
	// 初始化声音
	initSoundDoc() {
		//播放声音 audio
		//this.myAudio = document.getElementById("audio");
		this.myAudio = this.$refs.alarmAudio;
		
		this.myAudio.load();
		if(!this.myAudio.paused){
			this.myAudio.pause();
			//this.myAudio.paused=true;
		}
	},
	
	//开始播放 声音
	soundStart() {
		
		// 不允许播放
		if(!this.$store.getters.getAllowVoiceFlag) return false;
		// 声音已开启
		if(!this.myAudio.paused) return false;
	
		this.myAudio.play();
		//this.myAudio.paused=false;
		this.myAudio.loop = "loop";
		this.myAudio.muted = false;
		
	},
	
	//停止播放声音
	soundStop(){
		this.myAudio.muted = true;
		this.myAudio.load();
		if(!this.myAudio.paused){
			this.myAudio.pause();
			//this.myAudio.paused=true;
		}
	},
	
	//暂停播放声音
	soundPause(){
		this.myAudio.muted = true;
		this.myAudio.pause();
		//this.myAudio.paused=true;
	},
	
	//=========================  播放报警音 end  ======================== \\
	
	//========================== queue alarms start ==========================
	/**
	 * @Des 初始化 queue alarms 参数
	 * @Auth
	 * @Date 2021/8/5
	 */
	initQueueVar() {
		// list 记录报警设备id
		this.alarmTagIds = [];
		// 下标 报警设备
		this.index_alarmTagId = 0;
		// 下标 报警设备
		this.index_alarmVoice = 0;
		// 计时器 循环 报警设备
		this.timer_queueTagId = null;
		// 计时器 循环 报警声音
		this.timer_queueVoice = null;
		// 队列开关
		this.voiceQueueFlag = false;
	},
	// 队列播放 报警设备
	queueAlarmTagIds() {
		
		// 清除定时器
		if (this.timer_queueTagId != null) {
			clearTimeout(this.timer_queueTagId);
			this.timer_queueTagId = null;
		}
		// 清除定时器
		if (this.timer_queueVoice != null) {
			clearTimeout(this.timer_queueVoice);
			this.timer_queueVoice = null;
		}
		
		// 下标超出list长度 重置 index
		if (this.index_alarmTagId >= this.alarmTagIds.length) {
			this.index_alarmTagId = 0;
		}
		
		// 报警设备
		var tagId = this.alarmTagIds[this.index_alarmTagId];
		
		// 队列开关
		if (!this.voiceQueueFlag) {
			// 下标 报警设备
			this.index_alarmTagId = 0;
			// 下标 报警设备
			this.index_alarmVoice = 0;
			return false;
		}
		
		// tagId 空值 直接下一次循环
		if (this.$checkEmpty(tagId)) {
			// 下标 报警设备
			this.index_alarmTagId++;
			// 计时器 循环 报警设备
			this.timer_queueTagId = setTimeout(() => {
				// 队列播放 报警设备
				this.queueAlarmTagIds();
			}, 500);
			return false;
		}
		
		// 下标 报警设备
		this.index_alarmVoice = 0;
		// 队列播放 报警音
		this.queueVoice(tagId);
		
	},
	// 队列播放 报警音
	queueVoice(tagId) {
		// 清除定时器
		if (this.timer_queueVoice != null) {
			clearTimeout(this.timer_queueVoice);
			this.timer_queueVoice = null;
		}
		
		// 报警数据
		var alarmRow = this.map_tag_alarm.get(tagId);
		var alarmList = !this.$checkEmpty(alarmRow) && !this.$checkEmpty(alarmRow.list) ? alarmRow.list : [];
		
		// 队列开关
		if (!this.voiceQueueFlag) {
			// 下标 报警设备
			this.index_alarmTagId = 0;
			// 下标 报警设备
			this.index_alarmVoice = 0;
			return false;
		}
		
		// alarmList 空值 || 声音下标大于等于alarmList长度 直接下一次循环
		if (this.$checkEmpty(alarmList) || this.index_alarmVoice >= alarmList.length) {
			// 下标 报警设备
			this.index_alarmTagId++;
			// 计时器 循环 报警设备
			this.timer_queueTagId = setTimeout(() => {
				// 队列播放 报警设备
				this.queueAlarmTagIds();
			}, 500);
			return false;
		}
		
		// 报警信息
		var row = alarmList[this.index_alarmVoice];
		// 报警声音 地址
		var voiceFilePath = row.voiceFilePath;
		var voiceFileAddr = row.voiceFileAddr;
		
		// alarm msg 有值
		if (!this.$checkEmpty(row.alarmDes)) {
			// 报警信息展示框
			document.querySelector('.alarmMsgBox').getInnerHTML(row.alarmDes).slideDown();
		}
		
		// 报警音 空值  下一个报警声音
		if (!this.$store.getters.getAllowVoiceFlag || this.$checkEmpty(row) || this.$checkEmpty(voiceFilePath)) {
			
			var canAlarm_old = this.$store.getters.getAllowVoiceFlag;
			// 计时器 循环 报警设备
			this.timer_queueVoice = setTimeout(() => {
				
				// 可播放声音 开关改变 中止
				if (canAlarm_old != this.$store.getters.getAllowVoiceFlag) {
					return true;
				}
				
				// 关闭 报警信息展示框
				document.querySelector('.alarmMsgBox').slideUp(() => {
					
					// 可播放声音 开关改变 中止
					if (canAlarm_old != this.$store.getters.getAllowVoiceFlag) {
						return true;
					}
					
					// 下标 报警设备
					this.index_alarmVoice++;
					// 有值
					if (!this.$checkEmpty(alarmList[this.index_alarmVoice])) {
						// 队列播放 报警音
						this.queueVoice(tagId);
						return false;
					}
					
					// 下标 报警设备
					this.index_alarmTagId++;
					// 队列播放 报警设备
					this.queueAlarmTagIds();
					
				});
				
			}, 4 * 1000);
			
			
			return false;
		}
		
		// audio
		var $audio = document.querySelector('#audio');
		var audioSrc = getBasePath() + voiceFilePath;
		// 重置 src
		$audio.prop({'loop': false, 'muted': false}).attr({'src': audioSrc, 'cord_src': audioSrc});
		
		// 事件监听 audio 播放完毕
		$audio.off('ended').on('ended', () => {
			
			// 关闭 报警信息展示框
			document.querySelector('.alarmMsgBox').slideUp(() => {
				
				// 队列开关
				if (!this.voiceQueueFlag) {
					// 下标 报警设备
					this.index_alarmTagId = 0;
					// 下标 报警设备
					this.index_alarmVoice = 0;
					return false;
				}
				
				// 下标 报警设备
				this.index_alarmVoice++;
				
				// 有值
				if (!this.$checkEmpty(alarmList[this.index_alarmVoice])) {
					// 队列播放 报警音
					this.queueVoice(tagId);
					return false;
				}
				
				// 下标 报警设备
				this.index_alarmTagId++;
				// 队列播放 报警设备
				this.queueAlarmTagIds();
				
			});
			
		});
		
		// 监听出错
		$audio.off('error').on('error', () => {
			
			// 清除定时器
			if (this.timer_queueVoice != null) {
				clearTimeout(this.timer_queueVoice);
				this.timer_queueVoice = null;
			}
			
			// 计时器 循环 报警设备
			this.timer_queueVoice = setTimeout(() => {
				
				// 关闭 报警信息展示框
				document.querySelector('.alarmMsgBox').stop().slideUp(() => {
					
					// 队列开关
					if (!this.voiceQueueFlag) {
						// 下标 报警设备
						this.index_alarmTagId = 0;
						// 下标 报警设备
						this.index_alarmVoice = 0;
						return false;
					}
					
					// 下标 报警设备
					this.index_alarmVoice++;
					
					// 有值
					if (!this.$checkEmpty(alarmList[this.index_alarmVoice])) {
						// 队列播放 报警音
						this.queueVoice(tagId);
						return false;
					}
					
					// 下标 报警设备
					this.index_alarmTagId++;
					// 队列播放 报警设备
					this.queueAlarmTagIds();
					
				});
				
			}, 4 * 1000);
			
		});
		
		// 静音
		$audio[0].muted = true;
		// 加载
		$audio[0].load();
		// 播放
		$audio[0].play();
		myAudio.paused=false;
		// 静音
		$audio[0].muted = false;
		
		// 声音时长
		var voiceLength = row.voiceLength;
		// 休眠时间
		var sleepTime = parseInt(voiceLength) * 1000 + 500;
		
		return false;
		// 计时器 循环 报警设备
		this.timer_queueVoice = setTimeout(() => {
			// 队列开关
			if (!this.voiceQueueFlag) {
				// 下标 报警设备
				this.index_alarmTagId = 0;
				// 下标 报警设备
				this.index_alarmVoice = 0;
				return false;
			}
			
			// 下标 报警设备
			this.index_alarmVoice++;
			
			// 有值
			if (!this.$checkEmpty(alarmList[this.index_alarmVoice])) {
				// 队列播放 报警音
				this.queueVoice(tagId);
				return false;
			}
			
			// 下标 报警设备
			this.index_alarmTagId++;
			// 队列播放 报警设备
			this.queueAlarmTagIds();
			
		}, sleepTime);
		
	},
	
	// 开始播放 队列
	startVoiceQueue() {
		// 队列开关
		this.voiceQueueFlag = true;
		// 队列播放 报警设备
		this.queueAlarmTagIds();
	},
	// 关闭声音 队列
	stopVoiceQueue() {
		
		// 清除定时器
		if (this.timer_queueTagId != null) {
			clearTimeout(this.timer_queueTagId);
			this.timer_queueTagId = null;
		}
		// 清除定时器
		if (this.timer_queueVoice != null) {
			clearTimeout(this.timer_queueVoice);
			this.timer_queueVoice = null;
		}
		
		// 下标 报警设备
		this.index_alarmTagId = 0;
		// 下标 报警设备
		this.index_alarmVoice = 0;
		
		// audio
		var $audio = document.querySelector('#audio');
		// 停止
		if($audio && !$audio.paused){
			$audio.pause();
			$audio.paused=true;
		}
		// 重置 src
//		$audio.prop({'loop': false, 'muted': true, 'src': '', 'cord_src' : null});
		
		// 队列开关
		this.voiceQueueFlag = false;
		
		// 关闭 报警信息展示框
//		document.querySelector('.alarmMsgBox').stop().fadeOut();
		
	},
	//========================== queue alarms end ==========================
	
};

//================================= export =============================
export default {
	name: name,
	data: data,
	props: props,
	methods: methods,
	components: components,
	created: created,
	mounted: mounted,
	beforeDestroy: beforeDestroy,
	destroyed: destroyed,
	computed: computed,
	watch: watch,
}









// WEBPACK FOOTER //
// ./src/static_dazzle/js/sub-watch-data.js